export const eventsTableStyle = {
  wrapper: {
    background: 'var(--default-white)',
    padding: '12px 16px',
    width: '100%',
    height: '100%',
    minHeight: 'calc(100vh - 128px)',
    boxShadow: 'var(--box-shadow--1)',
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
  },

  tableContent: {
    position: 'relative',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },

  container: {
    overflowX: 'hidden',
  },

  table: {
    minWidth: 650,
    tableLayout: 'fixed',
    borderCollapse: 'separate',
    borderSpacing: '0 8px',
  },

  tableHeader: {
    height: '32px',

    '& > :nth-of-type(1)': {
      width: '8%',
    },
    '& > :nth-of-type(2)': {
      width: '20%',
    },
    '& > :nth-of-type(3)': {
      width: '30%',
    },
    '& > :nth-of-type(4)': {
      width: '24%',

      '@media (max-width: 1023.98px)': {
        display: 'none',
      },
    },
    '& > :nth-of-type(5)': {
      width: '12%',
      textAlign: 'right',
    },
    '& > :nth-of-type(6)': {
      width: '6%',
    },
  },

  headerCellTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    cursor: 'default',
  },

  headerCellTitleSortable: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    cursor: 'pointer',
  },

  sortIcon: {
    width: '20px',
    display: 'flex',
    alignItems: 'center',
  },

  tableBody: {
    '& > :nth-of-type(4)': {
      '@media (max-width: 1023.98px)': {
        display: 'none',
      },
    },

    '& .MuiTableCell-root': {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      padding: '7px',
    },
  },

  organizationCell: {
    display: 'flex',
    gap: '12px',
    alignItems: 'center',
    height: '58px',
  },

  avatar: {
    width: '44px',
    height: '44px',
    borderRadius: '50%',
    overflow: 'hidden',
    flexShrink: 0,

    img: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
  },

  name: {
    fontWeight: '700 !important',
    color: 'var(--neutral-900)',
    wordBreak: 'break-word',
    whiteSpace: 'normal',
  },

  email: {
    color: 'var(--neutral-300) !important',
    wordBreak: 'break-word',
    whiteSpace: 'normal',
  },

  textID: {
    fontSize: '12px',
  },

  dateLabel: {
    color: 'var(--neutral-300)',
    width: '37px',
    display: 'inline-block',
  },

  statusActive: {
    color: 'var(--success-600) !important',
    textAlign: 'right',

    '&:after': {
      paddingLeft: '10px',
      content: "'·'",
      fontSize: '23px',
    },
  },

  statusBlocked: {
    color: 'var(--error-600) !important',
    textAlign: 'right',

    '&:after': {
      paddingLeft: '10px',
      content: "'·'",
      fontSize: '23px',
    },
  },

  statusDefault: {
    color: 'var(--neutral-600)',
    textAlign: 'right',

    '&:after': {
      paddingLeft: '10px',
      content: "'·'",
      fontSize: '23px',
    },
  },

  menu: {
    '&.MuiTableCell-body': {
      padding: '0 5px',
    },
  },

  menuItem: {
    width: '100%',
    padding: '8px 16px',
    cursor: 'pointer',
    textTransform: 'capitalize',

    '&:hover': {
      backgroundColor: 'var(--background-grey-op-50-1)',
    },
  },

  paginationContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '40px',
  },

  loader: {
    position: 'absolute',
    left: 'calc(50% - 25px)',
    top: '200px',
  },

  modal: {
    '.MuiPaper-root': {
      maxWidth: '770px',
      padding: '48px 200px',
      width: '100%',
    },
  },

  textWrapper: {
    marginTop: '8px',
    textAlign: 'center',
  },

  description: {
    display: 'inline',
    color: 'var(--neutral-300)',
    textAlign: 'center',
  },

  descriptionBottom: {
    color: 'var(--neutral-300)',
    textAlign: 'center',
    marginTop: '16px',
  },

  bold: {
    color: 'var(--neutral-600)',
    fontWeight: '700',
    display: 'inline',
  },
};
